<!-- global testFreaks -->
<script>
  import { onMount } from 'svelte';

  /**
   * Loads the TestFreaks script and initializes it if available.
   * Sets the testFreaksLoaded flag to true upon successful initialization.
   * Logs an error if the TestFreaks script is not loaded.
   */
  function loadTestFreaks() {
    // Check if the TestFreaks object is available in the window
    if (typeof window.testFreaks !== 'undefined') {
      // Initialize TestFreaks with the 'seller' parameter
      window.testFreaks.push(['load', ['seller']]);
      // Set the flag indicating TestFreaks has been successfully loaded
    } else {
      // Log an error if TestFreaks is not available
      console.error('testFreaks not loaded');
    }
  }

  onMount(() => {
    /**
     * Dynamically adds the TestFreaks script to the document head when the component mounts.
     * The script is removed from the head when the component is destroyed.
     */

    // Create a new script element
    const script = document.createElement('script');
    // Set the script source to the TestFreaks script URL
    script.src = 'https://js.testfreaks.com/onpage/extrastores.com/head.js?v=4';

    script.defer = true;
    // Assign the loadTestFreaks function to execute upon successful script load
    script.onload = loadTestFreaks;
    // Append the script to the document head
    document.head.appendChild(script);

    return () => {
      // Remove the script from the document head upon component destruction
      document.head.removeChild(script);
    };
  });
</script>

<div id="testfreaks-seller-slider" class="testfreaks-container"></div>
